import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import {
  ElementHorizontalAlignment,
  LabelIconAlignment,
  makeFontStyleStyles,
  makeLabelHorizontalAlignStyles,
  PropertiesConfigInputFontStyleOptions,
} from '@blaze-shared/elements-domain';
import { FontsService, IconsModule } from '@blaze-shared/theming-data-access';

@Component({
  selector: 'blaze-element-header',
  imports: [NgStyle, IconsModule],
  templateUrl: './element-header.component.html',
  styleUrl: './element-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementHeaderComponent {
  private readonly fontsService = inject(FontsService);

  color = input<string | null | undefined>('');
  horizontalAlign = input<ElementHorizontalAlignment | null | undefined>('left');
  fontFamily = input<string | null | undefined>('var(--bat-headerFontFamily)');
  fontSize = input<string | null | undefined>('var(--bat-headerFontSize)');
  fontStyle = input<PropertiesConfigInputFontStyleOptions | null | undefined>([]);
  fontWeight = input<string | null | undefined>('var(--bat-headerFontWeight)');

  icon = input<string | null | undefined>();
  iconPosition = input<LabelIconAlignment | null | undefined>('left');
  iconSize = input<string | null | undefined>('var(--bat-headerIconSize)');
  iconColor = input<string | null | undefined>('');

  labelStyles = computed(() => {
    return {
      ...makeLabelHorizontalAlignStyles(this.horizontalAlign() ?? undefined),
      fontFamily: this.fontFamily(),
      fontSize: this.fontSize(),
      fontWeight: this.fontsService.getFontWeight(this.fontFamily(), this.fontWeight()),
      flexDirection: this.iconPosition() === 'right' ? 'row-reverse' : 'row',
    };
  });

  textStyles = computed(() => {
    return {
      ...makeFontStyleStyles(this.fontStyle() ?? []),
    };
  });

  iconStyles = computed(() => {
    return {
      '--icon-size': this.iconSize(),
      color: this.iconColor(),
      marginLeft: this.iconPosition() === 'right' ? '-0.3em' : undefined,
    };
  });
}
